import { Checkbox } from "@fluentui/react-components";
import React, { useContext, useMemo } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";

type Props = { className?: string };

export const SelectAllCheckbox = ({ className }: Props) => {
  const { columns, onDeselectAll, onSelectAll, strings, id } =
    useContext(ColumnOptionsContext);
  const areAllVisible = useMemo(() => {
    return !columns.some((c) => !c.isVisible && !c.isFixed);
  }, [columns]);

  return (
    <Checkbox
      id={id ? `${id}-checkbox-all` : undefined}
      data-testid="column-options-select-all"
      className={className}
      label={
        areAllVisible
          ? strings.visibilityDeselectAllTitle
          : strings.visibilitySelectAllTitle
      }
      onChange={() => {
        if (areAllVisible) {
          onDeselectAll();
        } else {
          onSelectAll();
        }
      }}
      checked={areAllVisible}
    />
  );
};
